import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const branchPermissionURL = `api/v1/auth/branch/branch-role`;

//obtaining the paginated data
export const getBranchPermission = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(
    `${branchPermissionURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllBranchPermission = () => axiosInstance.get(`${branchPermissionURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageBranchPermission = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(
    `${branchPermissionURL}/list?offset=${(number - 1) * rowsPerPage}&limit=${rowsPerPage}&ordering=-id`
  );

export const getBranchPermissionById = (id) => axiosInstance.get(`${branchPermissionURL}/retrieve/${id}`);

//creating function
export const createBranchPermission = (body) => axiosInstance.post(`${branchPermissionURL}/create`, body);
//updating function
export const updateBranchPermission = (id, body) => axiosInstance.patch(`${branchPermissionURL}/update/${id}`, body);

//searching function
export const handleSearch = (search, rowsPerPage) =>
  axiosInstance.get(`${branchPermissionURL}/list?offset=0&limit=${rowsPerPage}&search=${search}`);

// checking the redundant data
export const checkRedundantDataPermissionName = (e, cancelToken) =>
  axiosInstance.get(`${branchPermissionURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
